module.exports = __webpack_public_path__ + "img/on-boarding-add-ons.566f9211.png";